import { render, staticRenderFns } from "./BindsAppContent.vue?vue&type=template&id=c400ddb4&"
import script from "./BindsAppContent.vue?vue&type=script&lang=js&"
export * from "./BindsAppContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsAppContent.vue?vue&type=style&index=0&id=c400ddb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports